const months = {
	"1": "Jan",
	"2": "Feb",
	"3": "Mär",
	"4": "Apr",
	"5": "Mai",
	"6": "Jun",
	"7": "Jul",
	"8": "Aug",
	"9": "Sep",
	"10": "Okt",
	"11": "Nov",
	"12": "Dez"
}
function getDateAfterNDays(N) {
	if (!N || isNaN(N)) {
		return null;
	}

	const currentDate = new Date();
	currentDate.setDate(currentDate.getDate() + N);

	const monthNumber = currentDate.getMonth() + 1;
	const month = months[monthNumber].substr(0,3)
	const day = currentDate.getDate();

	return {
		day,
		month: month.toString()
	};
}

function calcShippingDate() {
	document.querySelectorAll('.shipping-date-value').forEach(el => {
		const sumDays = Number(el.dataset.sumDays)
		const shippingDate = getDateAfterNDays(sumDays)
		el.innerText = `${shippingDate.month} ${shippingDate.day}`
	})
}

document.addEventListener("DOMContentLoaded", () => {
	calcShippingDate()
})